import { useContext } from 'react'

import {
  Button, Form, ModalContext, SidebarModal,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import useSystem, { useSystemForm } from '@hooks/useSystem'

import ToggleListItem from '@components/ToggleListItem'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

const MODAL_KEY = 'ManageSystemMaintenanceModal'

type ModalCallbacks = {
  closeModal: () => void,
  updateSystem: (payload: HandleCallbackActionParams) => Promise<object>,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  showModal: boolean,
}

const ManageSystemMaintenanceModal = (props: ModalProps) => {
  const { callbacks, showModal } = props
  const { closeModal, updateSystem } = callbacks || {}

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, MODAL_KEY, {})
  const { system } = modalPayload

  const {
    callbacks: { updateSystem: updateFn },
    updating,
  } = useSystem(system)

  const {
    entityState,
    entityState: {
      maintenance_message,
      maintenance_mode,
    },
    handlers,
    setEntityState,
  } = useSystemForm(system, { validateOn: 'change' })

  const updateSystemPayload = {
    callbacks: {
      action: updateFn,
      afterAction: closeModal,
    },
    entityParams: entityState,
    toastText: 'System Updated',
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Manage" titleSecondLine="Maintenance" />

      <SidebarModal.Content>
        <Form>
          <ToggleListItem
            onClick={() => setEntityState({ maintenance_mode: !maintenance_mode })}
            toggleOnText="On"
            toggleOffText="Off"
            toggleValue={maintenance_mode}
          >
            <ToggleListItem.Title>Maintenance Mode</ToggleListItem.Title>
          </ToggleListItem>

          <Form.Field label="Message">
            <textarea
              name="maintenance_message"
              style={{ height: 120 }}
              // @ts-expect-error TS2322
              type="text"
              value={maintenance_message}
              {...handlers}
            />
          </Form.Field>
        </Form>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          loading={updating}
          onClick={() => updateSystem(updateSystemPayload)}
          size="large"
        >
          Save Maintenance Mode
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <ManageSystemMaintenanceModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
